export default __webpack_public_path__ + "02cfde88852734c13833132c65346e90.jpg";